import React, { useState } from 'react';
import {
  List,
  ListItemButton,
  ListItemText,
  Collapse,
  Box,
  Typography,
  Paper,
} from '@mui/material';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import Scrollbars from 'rc-scrollbars';

// Данные из файла, разбитые по разделам
const sectionsData = [
  {
    title: 'Первичная настройка аккаунта',
    content: `Когда вы только получили логин и пароль, нужно настроить аккаунт.

Для этого в правом верхнем углу нужно нажать на троеточие и выбрать пункт «настройки».

Вы увидите 3 раздела: основное, реквизиты и Интеграция по API.

В разделе «основное» вы можете указать либо отредактировать свои ФИО, электронную почту, номер телефона и аватар. Так же вы можете установить иконку для «вашего маркетплейса».

Ваш маркетплейс — это аналог обычного маркетплейса, если вы продаете свои товары где-то помимо WB и OZON. К нему вернемся позже.

В разделе «реквизиты» вы можете указать всю юридическую информацию о вашем ИП или ООО. Вся эта информация понадобится в дальнейшем для правильного оформления документов и этикеток.

Раздел «интеграция по API» вы можете указать ключи доступа к вашим аккаунтам на маркетплейсах. Это позволит вам работать с карточками товаров, созданными вами на соответствующем маркетплейсе, видеть статистику и создавать сделки для соответствующего маркетплейса.`,
  },
  {
    title: 'Мои товары',
    content: `В разделе сайта «Мои товары» вы можете работать со списком ваших товаров на соответствующем маркетплейсе. Если выбран ваш маркетплейс, то тут вы можете добавить карточки товаров.

Основная задача данного раздела заполнить Технические задания для товаров, загрузить КИЗы, а также выбрать какой ШК будет использоваться для товара, если на маркетплейсе их указано несколько. Обратите внимание, что все настройки товара привязываются к конкретному ШК, если вы создадите технические задания и загрузите КИЗы для одного ШК, а позже выберете другой ШК, то все технические задания и КИЗы нужно будет привязывать по новой.`,
  },
  {
    title: 'Окно загрузки КИЗов',
    content: `Данное окно доступно для каждого товара при нажатии на значок QR кода у товара. Тут вы можете загрузить файлы с КИЗами для товаров, посмотреть доступные и использованные КИЗы, удалить файлы или конкретные КИЗы при необходимости, а также, для использованных, скачать таблицу со списком использованных кодов, в формате подходящем для системы честного знака.`,
  },
  {
    title: 'Техническое задание',
    content: `Техническое задание делится на внешнюю и внутреннюю части. Внешняя часть состоит из краткого отображения комментария и строки инструментов. Нажатие на комментарий открывает окно редактирования технического задания, предоставляющее следующие возможности:

1) Выбор услуг — действий, которые нужно сделать с товаром, перед тем как отгружать его. Для этого в левой верхней части нажмите на «+» и выберите те услуги, которые вам нужны.

2) Настройка услуг. Справа от выбора списка услуг есть окно, разделенное на разделы. Там вам необходимо подробнее описать услугу.

В общем случае, вам необходимо указать количество повторений услуги. Например, если вам нужно промаркировать товар дважды, то напротив услуги «маркировка товара» должна быть указана цифра 2.

Но есть и услуги, которые настраиваются глубже. К таким услугам относятся упаковка товара, комплектация товара и дополнительные расходники.

В Упаковке товара необходимо выбрать, во что конкретно нужно упаковать товар. Если выбрана «упаковка товара (ФФ)», то выбирать нужно из упаковочных материалов, предоставляемых фулфилментом. Если же выбрана «упаковка товара (клиент)», то упаковочные материалы будут выбираться

3) Под списком услуг вы можете увидеть поле ввода для комментария. Тут вы можете описать что-то дополнительное, чего не получилось описать с помощью услуг.

4) Слева вверху вы можете дать название техническому заданию, чтобы вам проще было найти среди других версий

5) Внизу страницы вы можете увидеть кнопки удалить и скрыть. Удалить — доступна только если техническое задание не используется ни в одной из ваших сделок. Скрыть — доступна всегда, они используется, чтобы не отображать больше это техническое задание при создании сделок, но при этом ранее созданные с этим техническим заданием останутся не тронуты.

6) В нижней части окна так же есть переключатель fbs, если он включен, то для fbs товаров будет использоваться именно это техническое задание. Важно, что только одна из версий технического задания для товара может быть fbs.

7) Кнопка сохранить заносит изменения на сервер, но важно понимать, как это может работать. Если вы создавали новое техническое задание, то оно просто будет создано и вы сможете его использовать. Если вы редактировали уже существующее задание, которое не используется ни в каких сделках, то любые изменения просто обновят его. Если же техническое задание уже используется в сделках, то в таком случае, изменяя такие поля как комментарий или услуги, то вам будет предложено создать альтернативную версию технического задания — изначальное останется без изменений, но создаться новое, которое охранит все изменения. Если же вы измените другие настройки, то они просто обновятся.

На панели инструментов вы можете раскрыть список услуг — это краткое описание услуг, описанных в техническом задании. Далее вы можете выбрать версию технического задания. Эта механика позволяет иметь для одного товара несколько вариаций обработки.

Далее на панели инструментов вы увидеть кнопки создать и скопировать. Создание — создает новую версию технического задания, а копирование позволяют скопировать текущую версию на другие товары, причем для каждого товара, на который вы копируете техническое задание создается новая версия.`,
  },
  {
    title: 'Расходники',
    content: `В своих технических заданиях вы указываете, во что нужно упаковывать товар, что добавить к нему дополнительно и из чего его нужно собрать. Все это — расходники.

В соответствующем разделе вы можете создать свои расходники. При создании вы заполняете всю необходимую информацию о расходнике, указывая названия, размер текст и тд. Но самыми важными полями тут являются единицы измерения и тип расходника.

Единицы измерения позволяют указать, в чем измеряется ваш товар, а также сколько находится в упаковке. Например, если у вас есть расходник в виде открытки с котиком, то вы оставляете единицу измерения «единицы» и указываете, что в 1 упаковке 1 штука. Если же вы создаете расходник скотч, то в единицах измерения вы указываете сантиметры, а в упаковке у вас уже должно содержаться 100 сантиметров скотча.

Тип расходника это то, для какой услуги он будет использоваться. На данный момент существует 3 типа:

1) Упаковка — этот тип будет использоваться в услуге «упаковка товара (клиент)». Это такие расходники как фирменный скотч или коробки, в которые вы хотите упаковывать свой товар.

2) Дополнительные — этот тип будет использоваться в услуге «Дополнительные расходники». Это такие расходники, которые вы просто добавляете товар. Например есть небольшая открытка с ссылками на ваши соцсети, которую вы добавляете ко всем своим товарам, это как раз дополнительных расходник.

3) Для комплектации — этот тип будет использован в услуге «комплектация товара». Такой тип используется в случаях, когда вы не привозите уже готовый товар, а привозите его составляющие. Например, у вас есть подарочные наборы со средствами гигиены разных размеров. Первый содержит шампунь и гель для душа, а тот, что побольше, дополнительно содержит бомбочку для ванной и мыло. Тогда вы отдельно привозите все комплектующие, а сотрудники склада по вашему техническому заданию комплектуют товар.

Когда расходники созданы, нужно привезти их на склад. Для этого нужно перейти в поставки расходников. Тут вы можете видеть список поставок, которые вы уже создавали, что в них содержалось и в каком они статусе.

Чтобы создать новую поставку, нажимаем кнопку «создать поставку» вверху страницы. После нажатия откроется окно, где будет список всех ваших расходников, вам нужно будет выбрать какие расходники вы хотите привезти и в каком количестве и нажать «добавить».

После этого откроется страница, где вы сможете указать информацию, необходимую для забора товара, проверить список, отредактировать его при необходимости и нажать «создать поставку».

Далее данная поставка называется «сделка». Вы можете наблюдать за процессом обработки через статус сделки. Когда товар пришел, его обработали и поставили на хранение, сделка с расходниками будет считаться завершенной.`,
  },
  {
    title: 'Сделки',
    content: `В данном разделе вы управляете своими сделками. Тут отображаются только сделки, относящиеся к выбранному маркетплейсу. Вы можете видеть все необходимые даты, относящиеся к сделке, товары, относящиеся к сделке, транзитный склад и склад назначения, детали сделки и ее статус.

Дата создания — создается автоматически, когда сделка была создана.

Дата поступления — указывается менеджером, когда сделка приехала на склад.

Дата отгрузки — указывается вами и корректируется менеджером, дата, когда сделка должна быть отгружена.

Товары — список товаров, с которым создавалась сделка, состоящий из 3 значений. Заявленное количество — то, сколько вы указали при создании сделки. Фактическое количество — количество, которое приехало по факту. Остаток — сколько товара сейчас содержится в данной сделке.

Транзитный склад

Склад назначения

Детали — тут в формате значков отображаются уточнения по сделки. Например, что это сделка из возвратов или что она собрана с хранения.

Статус сделки — один из 5 основных статусов «прием», «обработка», «хранение», «отгрузка», «завершенная»

При нажатии на значок информации, откроется шторка сделки. Тут вы можете больше подробностей по сделке, которые заполняет менеджер.

Если в этой шторке вы нажмете «открыть сделку», то перейдете на отдельную страницу с разделами «таблица», «привязка», «оплата»`,
  },
  {
    title: 'Создание сделки',
    content: `В разделе сделки есть кнопка создать сделку. Когда вы нажмете ее, откроется окно, в котором будут все ваши товары, привязанные к соответствующему маркетплейсу. Выберите те, которые хотите добавить в сделку и нажмите «добавить». Также можно нажать на иконку загрузки и вместо ручного указания товаров и их количества загрузить таблицу. Загрузка таблицы поддерживает шаблон с кросс-докингом.

На открывшейся странице сделки вы сможете указать информацию для забора товара, сразу прописать информацию для отгрузки товара и настроить список товаров. Если вы что-то забыли, всегда можно нажать добавить товар, а если добавили что-то лишнее, то напротив каждого товара есть иконка удаления.

Для каждого товара в этом списке вам нужно выбрать версию технического задания. Вы даже можете отредактировать или создать его прямо здесь.

Также вы можете проверить наличие КИЗов и пополнить список при необходимости.

Так же у каждого товара есть кнопка «указать уже готовую обработку». Представим ситуацию, что вы решили перевезти свой товар с одного склада на другой. А там товар был уже частично обработан. В таком случае, вы выбираете техническое задание, по которому его необходимо обработать, но в списке уже выполненных услуг отмечаете, что уже сделали с товаром. Это особенно важно для услуг с расходниками, чтобы не тратить лишние из ваших запасов.

После того, как все заполненно вы можете нажать «создать поставку» и ваша сделка будет создана. Если ни у каких товаров в техническом задании не указана комплектация, то сделка попадет в статус «прием товара». Если же у всех товаров в тз указана комплектация, то сделка попадет в статус «обработка товара». Если часть товара нужно собрать, а часть должна приехать на склад, то сделка попадет в статус «прием товара» и будет ждать, пока приедет весь необходимый товар.`,
  },
  {
    title: 'Сделка. Раздел таблица',
    content: `В данном разделе вы видите весь товар, который относится к открытой сделке. Каждая строка таблицы — это основная информация о товаре, выбранное техническое задание, окно с КИЗами и количество.`,
  },
  {
    title: 'Сделка. Раздел привязка',
    content: `В этом разделе вы можете посмотреть как распределен товар по паллетам и коробам. В левой части отображаются паллеты, если их раскрыть, то увидите короба, а если раскрыть их, то будет видно список товаров в коробе.

В правой части товара показывается нераспределенный по коробам товар. Так же, для некоторых сделок существует раздел распределение по складам, необходимое для кросс-докинга.

В этом разделе вы можете указать номер поставки и код поставки, предоставляемы маркетплейсом.

Так же вы можете скачать таблицу с привязкой товара, можете скачать список привязанных к товарам КИЗов, загрузить ШК для каждого короба, а также pdf для коробов, если сделка на озоне.`,
  },
  {
    title: 'Сделка. Раздел Оплата',
    content: `Здесь вы можете посмотреть какие услуги были оказаны и их стоимость. Данный раздел еще в разработке.`,
  },
  {
    title: 'Хранение товара',
    content: `В этом товаре вы можете видеть какой товар, в каком количестве и с каким техническим заданием сейчас находится на хранении склада. Всю эту информацию можно скачать в формате таблицы.

В этом разделе вы можете создать новую сделку из хранения, нажав кнопку «новая сделка». Когда вы нажмете ее, откроется окно, в котором будут все ваши товары, находящиеся на хранении и привязанные к соответствующему маркетплейсу. Выберите те, которые хотите добавить в сделку и нажмите «добавить». Также можно нажать на иконку загрузки и вместо ручного указания товаров и их количества загрузить таблицу. Загрузка таблицы поддерживает шаблон с кросс-докингом.

Важно уточнение, вы не можете добавить одновременна один и тот же товар с разными техническими заданиями.

На открывшейся странице будет уже знакомое окно создания сделки, с отсутствующей настройкой забора товара. На этой странице появляется новая настройка — выбор маркетплейса. Представим, что вам нужно срочно отгрузить товары на WB, но у вас недостаточно товара на хранении WB, зато есть товар на OZON. Тогда вы можете указать, что сделку нужно создать на WB. Такое действие возможно, если ШК товара на двух маркетплейсах одинаковый, либо указано соответствие в настройках ШК.

Техническое задание будет выбираться их тех, которые доступны для выбранного товара на итоговом маркетплейсе.

Когда вы нажмете кнопку создать сделку, он создаться со статусом обработка товара. В списке сделок вы будете видеть с какого маркетплейса на какой она была создана. А также у вас будет отображаться окно сбора товара, в котором вы можете увидеть из каких сделок собрана новая. Например, на хранении у вас были сделки 1 и 2. В каждой из них по 20 единиц товара, которые распределены по 5 штук в коробе. Тогда, при создании сделки 3 на 31 единицу товара, в окне сбора товара будет показано, что из сделки 1 забрали 4 короба, а из сделки 2 были забраны 2 короба и 1 единица товара из 3го короба.`,
  },
  {
    title: 'Настройки ШК',
    content: `В меню вы можете найти пункт «настройки ШК». В этом разделе вы можете указать соответствия ШК. Например, на WB и на OZON у вас продается абсолютно одинаковая футболка, но на каждом из маркетплейсов установлен свой ШК. Тогда, на данной странице вы можете указать, что эта футболка на WB с ШК1 соответствует такой же футболке на OZON с ШК2.`,
  },
  {
    title: 'Возвраты',
    content: `На данной странице вы можете видеть 3 раздела: возвраты, это те товары, которые клиенты просто вернули, но они целые и не относятся к категории самовыкупов, самовыкупы, это те товары, которые заказывали и возвращали вы сами, и брак, это те товары, которые вернули из-за наличия брака.

Товары из разделов «Возвраты» и «Самовыкуп» можно использовать повторно, просто нажмите на кнопку «обработать», выберите товары из списка и укажите на какой маркетплейс и с каким техническим заданием пойдет товар.

Товары из категории «Брак» вы можете только забрать. Просто нажмите кнопку «забрать» и сделка, в которой копились ваши товары с браком, перейдет в статус отгрузки, после чего вы можете договориться с менеджером о дате, когда сможете забрать весь свой брак.`,
  },
  {
    title: 'Сотрудники',
    content: `В меню вы можете найти пункт «сотрудники». По нажатию у вас откроется страница, где вы можете добавить своих сотрудников. Она состоит из двух частей: список сотрудников слева и список ролей справа.

Добавляя сотрудника, он получает доступ к вашему личному кабинету по своим логину и паролю. Список того, что может делать сотрудник регулируется ролью. Добавив роль, вы можете настроить, что могут делать сотрудники с этой ролью.

На данный момент страница и список доступов еще находятся в разработке, но вы уже можете добавить сотрудника и ограничить ему некоторые доступы.`,
  },
  {
    title: 'Связанный аккаунт',
    content: `В меню вы можете найти пункт «добавить аккаунт», при нажатии на который откроется окно создания нового аккаунта. После того, как вы заполните все поля, на указанную почту придет сообщение с логином и паролем, а при нажатии в верхнем меню на ваше имя, вы сможете выбирать, с каким аккаунтом сейчас работаете.

Данный аккаунт будет пустой и его нужно будет настроить с нуля. Такая механика необходима, когда вы работаете под разными юридическими именами.`,
  },
];

const ClientGuide = () => {
  const [openSections, setOpenSections] = useState({});

  const handleToggle = (title) => {
    setOpenSections((prev) => ({
      ...prev,
      [title]: !prev[title],
    }));
  };

  return (
    <Paper elevation={2} sx={{ width: "98%", height: "calc( 96% - 5px)", margin: "1%", padding: '16px', borderRadius: "10px"}}>
      <Typography variant="h5" sx={{ mb: 2, fontWeight: 'bold' }}>
        Содержание
      </Typography>
      <List component="nav" sx={{ width: '100%', height: "95%", bgcolor: 'background.paper' }}>
        <Scrollbars
            style={{ width: '100%', height: "100%"}} 
        >
            {sectionsData.map((section) => (
            <Box key={section.title} sx={{width: "98%"}}>
                <ListItemButton 
                    onClick={() => handleToggle(section.title)}
                    disableRipple  
                    sx={{
                        borderRadius: '30px',
                        backgroundColor: openSections[section.title] ? '#078476' : "ffffff",
                        borderStyle: 'solid',
                        borderWidth: '1px',
                        borderColor: openSections[section.title] ? '#065f52' : '#aaa8a8',
                        marginBottom: openSections[section.title]? '0px': '10px',    
                        '&:hover': {
                            backgroundColor: openSections[section.title] ? '#065f52' : '#f1f1f1',
                        },
                        color: openSections[section.title]? 'white': 'gray'
                    }}
                >
                <ListItemText
                    primary={section.title}
                    primaryTypographyProps={{ fontWeight: 'medium' }}
                />
                {openSections[section.title] ? <ExpandLess /> : <ExpandMore />}
                </ListItemButton>
                <Collapse in={openSections[section.title]} timeout="auto" unmountOnExit>
                <Box sx={{ pl: 4, pr: 2, py: 2 }}>
                    <Typography
                    variant="body2"
                    sx={{
                        whiteSpace: 'pre-wrap',
                        wordBreak: 'break-word',
                        color: 'text.secondary',
                    }}
                    >
                    {section.content}
                    </Typography>
                </Box>
                </Collapse>
            </Box>
            ))}
        </Scrollbars>
      </List>
    </Paper>
  );
};

export default ClientGuide;